import React, { Component } from "react";
import parse from "html-react-parser";
import Disclaimer from "./components/Disclaimer";
import StepButton from "./components/StepButton";
import ProgressBar from "./components/ProgressBar";
import IconSet from "./components/IconSet";
import StepsData from "./data/steps";
import QuestionSection from "./components/QuestionSection";
import Note from "./components/Note";
import Results from "./components/Results";
import PrintButton from "./components/PrintButton";
import RestartButton from "./components/RestartButton";
import { numberWithCommas } from "./util/util";

class App extends Component {
  constructor(props) {
    super(props);

    const questionArray = StepsData();
    // Create IDs for every question
    // E.g.
    // 1_0 = Step 1 Question 1
    // 1_1 = Step 1 Question 2
    // 2_0 = Step 2 Quesiton 1
    // For more info, check with Josh Wang
    const checkboxArrayValue = {};
    for (var i = 0; i < questionArray.length; i++) {
      for (var x = 0; x < questionArray[i]["question_list"].length; x++) {
        let displayValue = questionArray[i]["question_list"][x]["show"];
        let displayID = i + 1 + "_" + x;
        //
        checkboxArrayValue[displayID] = displayValue;
      }
    }
    this.state = {
      appName: 'Time-Saving Calculator',
      step: 1,
      // How many communities do you manage?
      communities: 100,
      // How many bank accounts do you reconcile each month?
      bankAccount: 200,
      // Approximately how long does it take to reconcile each account, including posting ending balance and interest earned?
      reconcileTime: 15,
      reconcilePPBTime: 5,
      statementTime: 60,
      statementPPBTime: 0,
      transfers: 1,
      transfersTime: 15,
      transfersPPBTime: 1,
      lockboxUpload: 10,
      lockboxPPBUpload: 0,
      lockboxDownload: 30,
      lockboxPPBDownload: 0,
      completedClick: false,
      timerPassed: false,
      positiveBoolean: 1,
      positivePay: 30,
      positivePayPPBTime: 0,
      research: 10,
      searching: 10,
      researchPPB: 0,
      stopPayment: 1,
      stopPaymentTime: 5,
      stopPaymentPPB: 0,
      newAccountOpen: 4,
      newAccountForms: 10,
      newAccountPPB: 3,
      accountingRate: 40,
      /* calculation value */
      reconciliationsTimeSaved: 0,
      statementTimeSaved: 0,
      transfersTimeSaved: 0,
      lockboxUploadSaved: 0,
      lockboxDownloadSaved: 0,
      lockboxTotal: 0,
      positivePayValue: 0,
      positivePayTime: 0,
      positivePaySaved: 0,
      researchSaved: 0,
      stopPaymentSaved: 0,
      newAccountSaved: 0,
      savingPerMonth: 0,
      savingPerYear: 0,
      totalSaved: 0,
      checkboxList: checkboxArrayValue,
      width: window.innerWidth,
    };
  }

  nextStep = () => {
    const { step } = this.state;
    this.setState({
      step: step + 1,
    });
  };

  prevStep = () => {
    const { step } = this.state;
    this.setState({
      step: step - 1,
    });
  };

  restart = () => {
    const questionArray = StepsData();
    // Create IDs for every question
    // E.g.
    // 1_0 = Step 1 Question 1
    // 1_1 = Step 1 Question 2
    // 2_0 = Step 2 Quesiton 1
    // For more info, check with Josh Wang
    const checkboxArrayValue = {};
    for (var i = 0; i < questionArray.length; i++) {
      for (var x = 0; x < questionArray[i]["question_list"].length; x++) {
        let displayValue = questionArray[i]["question_list"][x]["show"];
        let displayID = i + 1 + "_" + x;
        //
        checkboxArrayValue[displayID] = displayValue;
      }
    }
    this.setState({
      step: 1,
      timerPassed: false,
      checkboxList: checkboxArrayValue,
    });
  };

  completedStep = () => {
    const { step } = this.state;
    this.setState({
      step: step + 1,
      completedClick: true,
    });
    this.timer = setTimeout(() => this.setState({ timerPassed: true }), 3000);
  };

  calculateValues = () => {
    // Calcuate the Time Saved for Reconciliation section
    let reconciliationsTimeSaved =
      this.state.bankAccount * this.state.reconcileTime -
      this.state.bankAccount * this.state.reconcilePPBTime;
    let statementTimeSaved =
      this.state.statementTime - this.state.statementPPBTime;
    let transfersTimeSaved =
      (this.state.transfers * this.state.transfersTime -
        this.state.transfers * this.state.transfersPPBTime) *
      this.state.communities;
    let lockboxUploadSaved =
      this.state.lockboxUpload * 22 - this.state.lockboxPPBUpload * 22;
    let lockboxDownloadSaved =
      this.state.lockboxDownload * 22 - this.state.lockboxPPBDownload * 22;
    let lockboxTotal = lockboxUploadSaved + lockboxDownloadSaved;

    // Output the PositivePay Saved Time
    let positivePaySaved =
      this.state.positivePay * this.state.positiveBoolean * 22 -
      this.state.positivePayPPBTime * 22;

    let researchSaved =
      this.state.research * this.state.searching * this.state.communities -
      this.state.researchPPB * this.state.research * this.state.communities;
    let stopPaymentSaved =
      this.state.stopPayment *
        this.state.stopPaymentTime *
        this.state.communities -
      this.state.stopPaymentPPB *
        this.state.stopPayment *
        this.state.communities;
    let newAccountSaved =
      this.state.newAccountOpen * this.state.newAccountForms -
      this.state.newAccountOpen * this.state.newAccountPPB;
    // Total Saved
    let totalSaved =
      (reconciliationsTimeSaved +
        statementTimeSaved +
        transfersTimeSaved +
        lockboxUploadSaved +
        lockboxDownloadSaved +
        positivePaySaved +
        researchSaved +
        stopPaymentSaved +
        newAccountSaved) /
      60;
    let savingPerMonth = totalSaved * this.state.accountingRate;
    let savingPerYear = totalSaved * this.state.accountingRate * 12;

    return {
      reconciliationsTimeSaved,
      statementTimeSaved,
      transfersTimeSaved,
      lockboxUploadSaved,
      lockboxDownloadSaved,
      lockboxTotal,
      positivePaySaved,
      researchSaved,
      stopPaymentSaved,
      newAccountSaved,
      totalSaved,
      savingPerMonth,
      savingPerYear,
    };
  };

  setInputCheckbox(field, value, array) {
    if (!value && field === "positivePay") {
      // This part is set particular for question 5 statically, will need to look for a better way to do this in the future
      this.setState(
        {
          positiveBoolean: 0,
          checkboxList: array,
        },
        () => {
          var calculatedValues = this.calculateValues();
          this.setState({
            ...calculatedValues,
          });
        }
      );
    } else {
      // Checkbox
      this.setState(
        {
          positiveBoolean: 1,
          checkboxList: array,
        },
        () => {
          var calculatedValues = this.calculateValues();
          this.setState({
            ...calculatedValues,
          });
        }
      );
    }
  }

  setInputText(field, value) {
    if (value < 0) {
      value = 0;
    }
    // This is custom for question 1, so the bank account will listen to communites input and times 2
    if (field === "communities") {
      this.setState(
        {
          [field]: value,
          bankAccount: value * 2,
        },
        () => {
          var calculatedValues = this.calculateValues();
          this.setState({
            ...calculatedValues,
          });
        }
      );
    } else {
      this.setState(
        {
          [field]: value,
        },
        () => {
          var calculatedValues = this.calculateValues();
          this.setState({
            ...calculatedValues,
          });
        }
      );
    }
  }

  // Set State Event
  handleInputChange = (field, value, type, array) => {
    if (type === "checkbox") {
      this.setInputCheckbox(field, value, array);
    } else {
      this.setInputText(field, value);
    }
  };

  componentDidMount() {
    var calculatedValues = this.calculateValues();
    this.setState({
      ...calculatedValues,
    });
    // Add resize listener for window size change
    window.addEventListener("resize", this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
    // Remove Mobile detection listern
    window.removeEventListener("resize", this.handleWindowSizeChange);
  }

  // Update window size
  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  render() {
    // Add step
    const imageArray = IconSet();
    const stepList = StepsData();
    const { step } = this.state;
    const { width } = this.state;



    // Detecting the Medium ScreenSize for Tablet, everything below should be mobile devices
    const isMobile = width <= 768;

    let appName = this.state.appName;
    let totalStep = stepList.length;
    const description = `<h4>Looking to create efficiencies and potentially lower your operating costs?</h4>
     <p>Save time and money by easily automating manual processes. Download transaction data, check images, individual account statement files, and lockbox item images—all in one place.</p>
     <p>Use the calculator below to see the potential savings API Banking can bring.</p>
    `;

    let currentStepQuestion;
    let noteContent;
    if (step > totalStep) {
      currentStepQuestion = null;
      noteContent = null;
    } else {
      currentStepQuestion = stepList[step - 1]["question_list"];
      noteContent = stepList[step - 1]["note"];
    }

    const titleAsterisk = step > 1 && step !== stepList.length + 1
      ? ''
      : '*'
    

    // Format currency
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
    });

    // Format the state value
    let savingPerMonth = formatter.format(this.state.savingPerMonth);
    let savingPerYear = formatter.format(this.state.savingPerYear);

    const getDisclaimer = () => {
      if(step === 1) {
        return <Disclaimer />
      }
      return;
    }

    // Check if the all the step is completed
    if (step > totalStep) {
      // Show result page
      return (
        <div className="cal-app">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <ProgressBar totalStep={totalStep} currentStep={step} />
              </div>
            </div>
            <div
              className={
                this.state.timerPassed
                  ? "hide"
                  : "text-center mb-5 title-completed hide-on-print"
              }
            >
              {this.state.timerPassed ? "" : "Get Ready for Results"}
            </div>
            <Results
              appName={appName}
              totalSaved={this.state.totalSaved}
              savingPerYear={numberWithCommas(savingPerYear)}
              timerPassed={this.state.timerPassed}
              reconciliations={numberWithCommas(
                this.state.reconciliationsTimeSaved
              )}
              statement={numberWithCommas(this.state.statementTimeSaved)}
              transfer={numberWithCommas(this.state.transfersTimeSaved)}
              lockbox={numberWithCommas(this.state.lockboxTotal)}
              research={numberWithCommas(this.state.researchSaved)}
              positivePay={numberWithCommas(this.state.positivePaySaved)}
              stopPayment={numberWithCommas(this.state.stopPaymentSaved)}
              newAccount={numberWithCommas(this.state.newAccountSaved)}
              accountStaff={savingPerMonth}
              imageArray={imageArray}
            />
          </div>
          <div className="container">
            <div className="text-center my-5 anchor">
              <PrintButton
                timerPassed={this.state.timerPassed}
                currentStep={step}
              />
              <RestartButton
                timerPassed={this.state.timerPassed}
                restart={this.restart}
              />
            </div>
            <Disclaimer />
          </div>
        </div>
      );
      //}

      // End if step is greater than total step
    } else {
      // Show step page
      return (
        <div className="cal-app">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 col-md-11 col-lg-9">
                <ProgressBar totalStep={totalStep} currentStep={step} />
              </div>
            </div>
            <div className="app-step-container">
              <div className="row no-gutters bg-navy step-title">
                <div
                  className={
                    noteContent !== null ? "col-lg-8 col-sm-12" : "col-lg-12"
                  }
                >
                  <h2 className="text-center main-title">
                    <span>{step}</span>
                    <img
                      src={imageArray[step - 1]["src"]}
                      alt={this.props.Title}
                    />
                    {stepList[step - 1]["title"]}
                  </h2>
                </div>
              </div>

              <div className="full-width">
                <div className="row no-gutters">
                  <div
                    className={
                      noteContent !== null ? "col-lg-8 col-sm-12" : "col-lg-12"
                    }
                  >
                    <div className="wrapper">
                      {
                        // Map the array to generated the html and css
                        currentStepQuestion.map((question_num, i) => (
                          <QuestionSection
                            key={i}
                            id={`${step}_` + i}
                            stepNumber={this.state.step}
                            title={question_num["question"]}
                            propName={question_num["name"]}
                            currency={question_num["currency"]}
                            unit={question_num["unit"]}
                            popUp={question_num["popup"]}
                            type={question_num["type"]}
                            maxValue={question_num["max_value"]}
                            minValue={question_num["min_value"]}
                            step={question_num["range_step"]}
                            propValue={this.state[question_num["name"]]}
                            show={this.state.checkboxList[`${step}_` + i]}
                            checkbox={question_num["checkbox"]}
                            checkboxLabel={question_num["checkbox_label"]}
                            checkboxArray={this.state.checkboxList}
                            radioButtonQuestion={
                              question_num["radioButtonQuestion"]
                            }
                            radioButton={question_num["radioButton"]}
                            radioButtonOptions={
                              question_num["radioButtonOptions"]
                            }
                            onChange={this.handleInputChange}
                            isMobile={isMobile}
                          />
                        ))
                      }

                      <div className="text-center pt-4">
                        <StepButton
                          totalStep={totalStep}
                          nextStep={this.nextStep}
                          prevStep={this.prevStep}
                          completedStep={this.completedStep}
                          currentStep={step}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      noteContent !== null
                        ? "col-lg-4 col-sm-12 bg-lightgrey"
                        : "col-lg-12"
                    }
                  >
                    <Note
                      title={stepList[step - 1]["note_title"]}
                      content={stepList[step - 1]["note"]}
                    />
                  </div>
                </div>
              </div>
            </div>
            
            { getDisclaimer() }
          </div>
        </div>
      );
    }
  }
}

export default App;
